import { Typography } from '@mui/material'
import { getFormattedDateWithDay } from '../../../utils/helpers'
import { ReactComponent as Approve } from '../../../images/Approve.svg'
import { ReactComponent as Reject } from '../../../images/Reject.svg'
import { ReactComponent as CancelBySystem } from '../../../images/cancelBySystem.svg'
import CookiesStorageService from '../../../services/CookiesStorageService'

export const getActionText = (history, t, styles) => {
  const actionDate = getFormattedDateWithDay(history?.action_time)
  const currentEmployeeId = CookiesStorageService.getEmployeeId()
  if (history?.employee?.id === currentEmployeeId) {
    return history?.action_status?.key === 'APPROVED'
      ? `${t?.['Request has been approved by you on']} ${actionDate}`
      : `${t?.['Request has been rejected by you on']} ${actionDate}`
  }

  return (
    <>
      <Typography component="span" sx={styles.employeeName}>
        {history?.employee?.name}
      </Typography>
      {` ${history?.action_status?.name} ${t?.['the Request on']} ${actionDate}`}
    </>
  )
}

export const getSystemText = (history, t) => {
  const actionDate = getFormattedDateWithDay(history?.action_time)
  const key = history?.status?.key

  switch (key) {
    case 'COMPLETED_APPROVED':
      return `${t?.['Request has been Approved automatically by the System as no action required for this type of request.']} ${actionDate}`
    case 'COMPLETED_REJECTED':
      return `${t?.['Request has been Rejected automatically by the System.']} ${actionDate}`
    case 'TERMINATED':
      return `${t?.['Request has been Cancelled automatically by the System.']} ${actionDate}`
    default:
      return ''
  }
}

export const getIcon = (history, isSystem) => {
  if (isSystem) {
    return history?.status?.key !== 'COMPLETED_APPROVED' ? <Approve /> : <CancelBySystem />
  }
  return history?.action_status?.key === 'APPROVED' ? <Approve /> : <Reject />
}
